/*
 * @Description: Emarsys埋点统一上报工具集
 */

// 定义事件参数类型
type EmarsysEventParams = Record<string, any>;

export const Emarsys = {
  /**
   * @desc 普通埋点上报
   * @param eventName 事件名称
   * @param params 事件参数
   */
  track: (eventName: string, params: EmarsysEventParams): void => {
    try {
      if (window.sessionStorage.getItem('voo-emarsys-log-flog') === 'true') {
        console.log(`Emarsys, Event: ${eventName}`, params);
      }
      // 如果是非生产环境，固定testID用于测试
      const testId: number | null = import.meta.env.VITE_ENV !== 'production' ? 1959549 : null;
      const userId: string | null = localStorage.getItem('voo-userId');
      if (userId && eventName !== 'setCustomerId') {
        window.ScarabQueue?.push(['setCustomerId', testId || userId]);
      }
      window.ScarabQueue?.push([eventName, params]);
      window.ScarabQueue?.push(['go']);
    } catch (error) {
      console.log('Emarsys track error', error);
    }
  },
  /**
   * @desc 自定义埋点上报
   * @param tagName 标签名称
   * @param params 事件参数 - 可选
   */
  tag: (tagName: string, params?: EmarsysEventParams): void => {
    try {
      if (window.sessionStorage.getItem('voo-emarsys-log-flog') === 'true') {
        console.log(`Emarsys, Tag: ${tagName}`, params);
      }
      // 如果是非生产环境，固定testID用于测试
      const testId: number | null = import.meta.env.VITE_ENV !== 'production' ? 1959549 : null;
      const userId: string | null = localStorage.getItem('voo-userId');
      if (userId) {
        window.ScarabQueue?.push(['setCustomerId', testId || userId]);
      }
      if (params) {
        window.ScarabQueue?.push(['tag', tagName, params]);
      } else {
        window.ScarabQueue?.push(['tag', tagName]);
      }
      window.ScarabQueue?.push(['go']);
    } catch (error) {
      console.log('Emarsys track error', error);
    }
  },
  enabledLog(): void {
    window.sessionStorage.setItem('voo-emarsys-log-flog', 'true');
  },
  disabledLog(): void {
    window.sessionStorage.removeItem('voo-emarsys-log-flog');
  },
};
